import Pagination, { PaginationProps } from '@mui/material/Pagination';
import { SelectChangeEvent } from '@mui/material/Select';
import Select from 'atoms/Select';
import React from 'react';

import s from './Pagination.module.scss';

interface CustomPagination extends PaginationProps {
  offset?: number;
  limit?: number;
  total: number;
  onSetOffset: (offset: number, pageSize: number) => void;
  onSetLimit?: (limit: number) => void;
}

const CustomPagination = ({
  offset = 0,
  limit = 25,
  total,
  onSetOffset,
  onSetLimit,
  color = 'primary',
  ...rest
}: CustomPagination) => {
  const handleSetLimit = (event: SelectChangeEvent<unknown>) => {
    const pageSize = typeof event?.target?.value === 'number' ? event?.target?.value : limit;
    onSetLimit && pageSize && onSetLimit(pageSize);
  };

  return (
    <div className={s.Pagination}>
      <Pagination
        {...rest}
        page={Math.ceil((offset + 1) / limit)}
        count={Math.ceil(total / limit)}
        color={color}
        onChange={(event, page) => onSetOffset((page - 1) * limit, limit)}
      />
      {onSetLimit && (
        <Select
          className={s.Pagination__pageSize}
          value={limit}
          label="Page size"
          variant="standard"
          onChange={handleSetLimit}
          size="small"
          disableUnderline
          options={[
            { value: 10, name: '10' },
            { value: 25, name: '25' },
            { value: 50, name: '50' }
          ]}
        />
      )}
    </div>
  );
};

export default CustomPagination;
export type { PaginationProps };
